/**
 * Cookie Policy Page
 * Clean, minimal design using on record Color Bible
 */

import LegalPageLayout from '../components/LegalPageLayout'

export default function CookiePolicy() {
  return (
    <LegalPageLayout title="Cookie Policy" lastUpdated="January 2025">
      <div className="space-y-12" style={{ color: '#111111', lineHeight: '1.75' }}>
        {/* Introduction */}
        <section>
          <p className="text-lg">
            This Cookie Policy explains how on record uses cookies and similar technologies to recognize you when you
            visit our platform. It explains what these technologies are and why we use them, as well as your rights to
            control our use of them.
          </p>
        </section>

        {/* 1. What are cookies */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            1. What Are Cookies?
          </h2>
          <p>
            Cookies are small data files that are placed on your computer or mobile device when you visit a website.
            Cookies are widely used by website owners to make their websites work, or to work more efficiently, as well
            as to provide reporting information.
          </p>
        </section>

        {/* 2. Why we use cookies */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            2. Why We Use Cookies
          </h2>
          <p className="mb-4">
            We use cookies for several reasons:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" style={{ color: '#6B7280' }}>
            <li>To keep you signed in to your account</li>
            <li>To remember your preferences and settings</li>
            <li>To understand how you use our platform</li>
            <li>To improve our services and user experience</li>
            <li>To ensure the security of our platform</li>
          </ul>
        </section>

        {/* 3. Types of cookies */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            3. Types of Cookies We Use
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#0A2342' }}>
                3.1 Essential Cookies
              </h3>
              <p className="mb-3">
                These cookies are necessary for the website to function and cannot be switched off. They are usually only
                set in response to actions made by you such as setting your privacy preferences, logging in, or filling in
                forms.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#0A2342' }}>
                3.2 Analytics Cookies
              </h3>
              <p className="mb-3">
                These cookies allow us to count visits and traffic sources so we can measure and improve the performance
                of our site. They help us know which pages are the most and least popular and see how visitors move around
                the site.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold mb-3" style={{ color: '#0A2342' }}>
                3.3 Functionality Cookies
              </h3>
              <p className="mb-3">
                These cookies enable the website to provide enhanced functionality and personalization. They may be set by
                us or by third-party providers whose services we have added to our pages.
              </p>
            </div>
          </div>
        </section>

        {/* 4. Third-party cookies */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            4. Third-Party Cookies
          </h2>
          <p className="mb-4">
            In addition to our own cookies, we may also use various third-party cookies to report usage statistics,
            deliver advertisements, and for authentication purposes. These third parties include:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" style={{ color: '#6B7280' }}>
            <li>Google Analytics for usage statistics</li>
            <li>Authentication providers (Google, Apple) for sign-in functionality</li>
            <li>Content Delivery Networks (CDNs) for faster content delivery</li>
          </ul>
        </section>

        {/* 5. Managing cookies */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            5. How to Control Cookies
          </h2>
          <p className="mb-4">
            You have the right to decide whether to accept or reject cookies. You can exercise your cookie preferences by:
          </p>
          <ul className="list-disc list-inside space-y-2 ml-4" style={{ color: '#6B7280' }}>
            <li>Using the cookie consent tool when you first visit on record</li>
            <li>Adjusting your browser settings to refuse all or some browser cookies</li>
            <li>Deleting cookies that have already been set</li>
          </ul>
          <p className="mt-4">
            Please note that if you choose to block or delete cookies, some parts of on record may not work properly.
          </p>
        </section>

        {/* 6. Updates */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            6. Updates to This Policy
          </h2>
          <p>
            We may update this Cookie Policy from time to time. We will notify you of any changes by posting the new
            Cookie Policy on this page and updating the "Effective" date at the top.
          </p>
        </section>

        {/* 7. Contact */}
        <section>
          <h2 className="text-3xl font-bold mb-6" style={{ color: '#0A2342' }}>
            7. Contact Us
          </h2>
          <p className="mb-4">
            If you have questions about our use of cookies, please contact us:
          </p>
          <div style={{ color: '#6B7280' }}>
            <p>Email: <a href="mailto:contact@onrecord.live" style={{ color: '#FFD43B' }} className="hover:underline">contact@onrecord.live</a></p>
          </div>
        </section>
      </div>
    </LegalPageLayout>
  )
}
